import React, { useEffect } from 'react'
import '../style.css'
import { Variable } from '../Variable'
import AddRole from './AddRole'
import PopupPermission from '../permissions/PopupPermission'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom'
import SectionTopOfTable from '../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import { loadRoles } from '../../../store/Actions/ActionRolesAndPermissions'
import RoleSkeleton from '../../../components/general/general-component/skeleton-components/RoleSkeleton'
import { UsePermissions, hasPermissions } from '../../../components/general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../../components/general/general-component/check-permissions'
import CheckLazyLoader from '../../../components/general/general-component/check-lazy-loader'

function Roles() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { permissionss, loadingMainPermission } = UsePermissions();
    const rolesPer = hasPermissions([{ name: "roles" }], permissionss)
    const { roles, loadingRoles } = useSelectorCustom()
    const { state, setOpen, setopenPermission, setStateCustom } = Variable()
    const openRole = e => {
        e.preventDefault()
        setOpen(true)
    }
    const openPermission = (e, id) => {
        e.preventDefault()
        setStateCustom('role_id', id)
        setopenPermission(true)
    }
    useEffect(() => {
        dispatch(loadRoles())
    }, [])
    return (
        <CheckLazyLoader>
            <CheckPermissions array={rolesPer} loadingMainPermission={loadingMainPermission} >
                <main>
                    <div className='div_table margin_main shadow_main' >
                        <SectionTopOfTable langLocal={langLocal} title={translate('roles')} titleBtn={translate('add_role')} FunctionBtn={openRole} />
                        <div className='roles' dir={langLocal === 'ar' ? "rtl" : "ltr"} >
                            {
                                loadingRoles === false ? (
                                    roles.map((rr) => {
                                        return (
                                            <div className='oneRole card-hover' key={rr.id} onClick={(e) => openPermission(e, rr.id)} >
                                                <i className="las la-user-cog"></i>
                                                <p>{rr.name}</p>
                                            </div>
                                        )
                                    })
                                ) : <RoleSkeleton />
                            }
                        </div>
                    </div>
                </main>
            </CheckPermissions>
            {
                state.open && (
                    <AddRole open={state.open} setOpen={setOpen} />
                )
            }
            {
                state.openPermission && (
                    <PopupPermission translate={translate} open={state.openPermission} setOpen={setopenPermission} id={state.role_id} />
                )
            }
        </CheckLazyLoader>
    )
}

export default Roles